import { QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from '@redis-ui/components';

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1 } },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!query.meta?.errorToast) {
        return;
      }

      const { message, ...rest } = query.meta.errorToast;
      const finalMessage = typeof message === 'function' ? message(error, query) : message;

      toast.danger({ message: finalMessage, ...rest });
    }
  })
});
